import { render, staticRenderFns } from "./TranslateView.vue?vue&type=template&id=0f48e688"
import script from "./TranslateView.vue?vue&type=script&lang=js"
export * from "./TranslateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports